import { HelpCenter } from 'view/help-center';
import { ScreenName } from 'view/common/constants';
import { createRouteWithLayout } from 'util/resource-router';
import type { PaperAppearance } from 'view/layout/paper';

const route = {
    name: 'help-center',
    path: '/portals',
    exact: false,
    component: HelpCenter,
    resources: [],
};

const routeWithResource = {
    name: 'help-center',
    path: '/portals',
    exact: false,
    component: HelpCenter,
    resources: [],
};

const screenName = ScreenName.HELP_CENTER;

const paperAppearance: PaperAppearance = 'none';

const layoutProps = {
    paperAppearance,
    hideSearchButton: true,
    fadeInSearchModal: false,
};

export const helpCenterRoute = createRouteWithLayout(route, screenName, layoutProps);

export const helpCenterRouteWithResource = createRouteWithLayout(routeWithResource, screenName, layoutProps);
